import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { MixpanelCredentials } from '../types';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useMixpanelCredentials(tenant: number) {
  return useQuery<MixpanelCredentials>({
    queryKey: ['mixpanel-credentials', tenant],
    queryFn: async () => {
      try {
        const { data } = await axios.get(
          `${getBongoUrl()}/v1/org/${tenant}/integrations/mixpanel/credentials`
        );

        return data;
      } catch (error) {
        if (error.response.status === 404) {
          return null;
        }
      }
    },
  });
}
